import React, { Component, Fragment } from 'react';
import moment from 'moment';
import className from 'classnames';
import Countdown from 'react-countdown-now';
import { ReactComponent as RedTimer } from 'Icons/timer-red.svg';
import { connect } from 'react-redux';
import { GET_SERVER_TIME } from 'Constants/actionConstants';


class Timer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDate: this.props.currentTime ? moment(new Date(this.props.currentTime)): moment(new Date())
        };
    }

    componentDidMount() {
        this.setInitialStateData();
        this.getCurrentDate();
    }

    componentWillMount() {
        const { dispatch } = this.props;
        dispatch({
            type: GET_SERVER_TIME,
            onSuccess: (data) => {
                this.setState({ currentDate:  moment(new Date(data))},() => {
                    if(this.timerInterVal) {
                        clearInterval(this.timerInterVal);
                    }
                    this.getCurrentDate();
                })
            }
        })
    }


    componentWillReceiveProps(nextProps) {
        this.setInitialStateData(false, nextProps); 
        // this.getCurrentDate();
    }

//    shouldComponentUpdate(nextProps, nextState) {
//       if (this.props.currentTime !== nextProps.number) {
//          return false;
//       } else {
//          return true;
//       }
//    }

    setInitialStateData = (hasTimer, nextProps) => {
        // if((!nextProps) || (nextProps.from !== this.props.from ||  nextProps.to !== this.props.to)) {
            let { from, to , currentTime} = nextProps ? nextProps : this.props;
            this.setState({
                from: moment(from), 
                to: moment(to),
                // currentDate: currentTime ? moment(new Date(currentTime)): moment(new Date())
            }, () => {
                this.updateDiff();
                // this.setupTimer();
                // this.getCurrentDate();
            });
        // }
        if (this.props.isRelayBid && hasTimer) {
            this.interval = setInterval(() => {
                this.setInitialStateData();                 
            }, 2000);
        }
    }

    getCurrentDate = () => {
        const { currentDate }  = this.state;
        // if(this.timerInterVal) {
        //     clearInterval(this.timerInterVal);
        // }
        this.timerInterVal = setInterval(() => {
            this.setState({ currentDate: this.timerInterVal ? currentDate.add(1, 'seconds') : currentDate })                
        }, 1000);
    }

    setupTimer = () => {
        this.updateDiff();
        const intervalId = setInterval(() => {
            const duration = moment.duration(this.state.to.diff(this.state.currentDate));
            if(duration.days() == '0' && duration.hours() == '0' && duration.minutes() == '0') {
                clearInterval(this.state.intervalId);
                return;
            }
            this.setState({
                to: this.state.to.subtract(1, 'minutes')
            }, () => {
                this.updateDiff();
            })
        }, 1000 * 60);
        this.setState({
            intervalId: intervalId
        });
    }

    componentWillUnmount() {
        if(this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
        if (this.props.isRelayBid) {
            clearInterval(this.interval);
        }

        if(this.timerInterVal) {
            clearInterval(this.timerInterVal);
        }
    }
    


    updateDiff() {
        const { showInfo } = this.props;
        const prefix = showInfo ? 'Ends in ' : '';
        const duration = moment.duration(this.state.to.diff(this.state.currentDate));
        if(duration.minutes() < 0) {
            clearInterval(this.state.intervalId);
            return;
        }
        const years = duration.years();
        const months = duration.months();
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let formattedDiff = "";
        // Difference might be in years!
        if(years > 0) {
            formattedDiff = formattedDiff + (years > 0 ? years + ' Year(s) ': '');
        }
        if(months > 0) {
            formattedDiff = formattedDiff + (months > 0 ? months + ' Month(s) ': '');
        }
        if(days > 0) {
            formattedDiff = formattedDiff + (days > 0 ? days + ' Day(s) ': '');            
        }
        if(hours > 0) {
            formattedDiff = formattedDiff + (hours > 0  ? hours + 'h ': '');      
        }

        if(minutes > 0) {
            formattedDiff = formattedDiff + (minutes > 0  ? minutes + 'm ': '');      
        }

        if(seconds > 0) {
            formattedDiff = formattedDiff + (seconds > 0  ? seconds + 's ': '');   
        }

        this.setState({
            currentDiff: prefix + formattedDiff
        });

    }
    
    render() {
        let { from, to, currentDiff, currentDate } = (this.state || {});  
        const originalFrom = this.props.from;
        const originalTo = this.props.to;
        const showInfo = this.props.showInfo;
        const isBiddingExpired = to && currentDate.isAfter(to);
        const isBiddingYetToStart = from && from.isAfter(currentDate);
        const duration = to ? moment(new Date(to)) : moment(new Date());
        
        if (this.props.isRelayBid && (!duration || duration < originalTo)) {
            this.setInitialStateData(true);
        }
        // this.getCurrentDate();
        return (
            <Fragment>
                {originalFrom && originalTo && <div>
                    <RedTimer style={{ marginTop: 5, marginRight: 5 }} />
                    {
                        this.state && (isBiddingExpired || currentDiff == '0m' || (showInfo && currentDiff == 'Ends in 0m' )) && 
                        <>{ ((moment(new Date(to)).diff(currentDate) > -25000) && this.props.showCompleteError) ?
                            <span className="fs-14 lh-15p fBold error-color"> Your Bids are being processed, please wait for any bid window extensions </span> :
                            <span className="fs-14 lh-15p fBold blur-table-text-color "> Complete </span>
                        }
                        </>
                        
                    }
                    {
                        this.state && isBiddingYetToStart && !isBiddingExpired && <span className="fs-14 lh-15p fBold blur-table-text-color "> Yet To Start </span>
                    }
                    {
                        this.state && !isBiddingYetToStart && !isBiddingExpired && currentDiff != '0m' && !(showInfo && currentDiff == 'Ends in 0m') &&
                        <span className={className("fs-14 lh-15p fBold", {
                            'danger-color': currentDiff && currentDiff.indexOf('h') < 0 && currentDiff.indexOf('Day') < 0
                        })}> 

                        {
                            duration &&
                            <Countdown
                                date={duration.toDate()}
                                now={() => {
                                    return currentDate;
                                }}
                                renderer={
                                    ({ days, hours, minutes, seconds, completed }) => { if (!completed) {
                                            return (<span>
                                                Ends In {days} Day(s) {hours}H {minutes}M {seconds}S
                                            </span>);
                                        } 
                                        return null;
                                    }
                                }
                            />
                        }

                        </span>
                    }
                </div>}
                {
                    this.props.isRelayBid !== true && !(originalFrom && originalTo) && <div className="flex flex-middle">N/A</div>
                }
            </Fragment>
        )
    }
}

export default connect()(Timer);